// Docs https://www.npmjs.com/package/vue-fullpage.js
import Vue from 'vue';
import Fullpage from 'vue-fullpage.js';

Vue.use(Fullpage);
